import React from 'react';
import classNames from 'classnames';
import Header from './Header';
// import District from './District';
// import Networks from './Networks';
// import Projects from './Projects';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import TeamContact from './TeamContact';
import FeaturedResource from './FeaturedResource';

export default function Site(props) {
  const { supportQuestion, className, children } = props;

  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.SiteUpdate.Config(supportQuestion.id));
  }

  return (
    <div className={classNames(
      'flex flex-col bg-white',
      'shadow-cs-flat rounded-cs-10',
      '-m-0.5 border-2 border-cs-gray-100',
      'relative overflow-hidden',
      className
    )}>
      <div className="flex flex-col py-4 px-4 space-y-2">
        <div>
          <Header supportQuestion={supportQuestion} />
        </div>
        <div className="space-y-4">
          <div className="text-base text-cs-gray-500">
            <div className="font-semibold text-cs-gray-700 mb-2">
              Featured Resource
            </div>
            <FeaturedResource supportQuestion={supportQuestion} />
          </div>
          <div className="text-base text-cs-gray-500">
            <div className="font-semibold text-cs-gray-700 mb-2">
              Team Contact
            </div>
            <TeamContact supportQuestion={supportQuestion} />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
